import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Sparkles } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AiJobGenerator = ({ formData, onGenerated }) => {
  const [notes, setNotes] = useState('');
  const [loading, setLoading] = useState(false);

  const generate = async () => {
    if (!formData.title.trim()) {
      toast.error('Enter a job title first');
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.post(
        `${API}/admin/ai/generate-job`,
        {
          title: formData.title,
          sector: formData.sector,
          location: formData.location,
          experience: formData.experience,
          employment_type: formData.employment_type,
          notes,
        },
        { headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` } }
      );
      onGenerated(data);
      toast.success('Job description generated — review and edit as needed');
    } catch (error) {
      const detail = error.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'AI generation failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="border border-[#00D2D3]/40 bg-[#00D2D3]/5 p-4 space-y-3" data-testid="ai-job-generator">
      <div className="flex items-center gap-2 text-primary font-semibold text-sm">
        <Sparkles size={16} className="text-[#00b5b6]" /> AI Job Description Generator
        <span className="text-xs font-normal text-muted-foreground">· Claude Sonnet 4.6</span>
      </div>
      <p className="text-xs text-muted-foreground">
        Fill in Title, Sector, Location and Experience above, add any notes, and let AI draft the description, responsibilities and requirements.
      </p>
      <div className="flex flex-col sm:flex-row gap-2">
        <input
          type="text"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Optional notes: e.g. reports to CEO, plant turnaround, EV focus, team of 200..."
          data-testid="ai-job-notes"
          className="flex-1 px-3 py-2 text-sm border border-slate-300 focus:ring-2 focus:ring-primary outline-none bg-white"
        />
        <button
          type="button"
          onClick={generate}
          disabled={loading}
          data-testid="ai-job-generate-button"
          className="inline-flex items-center justify-center gap-2 bg-primary text-white px-4 py-2 text-sm font-semibold hover:bg-primary/90 disabled:opacity-50 whitespace-nowrap"
        >
          <Sparkles size={14} className={loading ? 'animate-pulse' : ''} />
          {loading ? 'Generating...' : 'Generate with AI'}
        </button>
      </div>
    </div>
  );
};

export default AiJobGenerator;
